import { TimeService_timeServiceGetGetTime } from '@festina/moneyin-general-types/moneyin-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchMoneyInTime = TimeService_timeServiceGetGetTime.useQuery
